import { Component, OnInit } from '@angular/core';
import {Location} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {ConfService} from '../conf.service';
import {AppComponent} from '../app.component';

@Component({
  selector: 'app-common-data-api',
  templateUrl: './common-data-api.component.html',
  styleUrls: ['./common-data-api.component.scss']
})
export class CommonDataApiComponent implements OnInit {
  access: any;
  men = [];
  operationGroups = [];
  categories = [];
  commons = [];
  businessTemplates = [];
  route: any;
  user: any;
  basicPermission: boolean;
  title = 'Common Data API';
  cardType = 'commonDataApi';
  buttonType = 'commonDataApi';
  categoryType: string;
  commonDataApi: any;
  partner = localStorage.getItem('partner');
  account = localStorage.getItem('account');
  panelOpenState = true;

  constructor(private location: Location,
              private router: Router,
              private _route: ActivatedRoute,
              private appComp: AppComponent,
              private confPost: ConfService) {
  }

  ngOnInit() {
    this.basicPermission = true;
    this.confPost.getCommonApisForPartner().subscribe(res => {
      this.commonDataApi = res;
    });
  }
}
